export default {
  mixMode: 'Mix Mode',
  referenceBudget: 'Reference Budget ({unit})',
  grid: 'Budget Grid ({count} budgets)',
  notFound: 'This budget simulation does not exist or was deleted.',
  backToList: 'Back to Budget Simulator',
  stillRunning: '{done} of {total} budgets computed. The details open once every budget is ready.'
}
